module.exports = __webpack_public_path__ + "static/media/cardloop.654bc5fb.mp4";